module.exports = __webpack_public_path__ + "img/user.45e14d55.png";